import { Component, OnInit, Injector, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../core/auth/authentication.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginViewComponent } from '../../../modules/application/login/login.view.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'djiv-account-activation',
  templateUrl: './djiv-account-activation.component.html',
  styleUrls: ['./djiv-account-activation.component.css']
})
export class DjivAccountActivationComponent implements OnInit {
  
  public $changePasswordForm: FormGroup;
  public $Error: string;
  public footerMessage: string;

  protected $router: Router;

  public passwordChangeSuccess: boolean = false; 
  public userAlreadyActive: boolean = false;
  public requestSent: boolean = false;

  private http: HttpClient;

  constructor(protected $injector: Injector, @Optional() public parent: LoginViewComponent) {
      this.$router = $injector.get(Router);  
      this.http = $injector.get(HttpClient);

      this.$changePasswordForm = new FormGroup({
          userName: new FormControl('', Validators.required),
          password: new FormControl('', Validators.required),
          confirmPassword: new FormControl('', Validators.required),
          urlkey: new FormControl(this.parent.urlKey)
      });   
      
      this.getUserStatus();    
  }

  ngOnInit() {
      this.footerMessage = "";
  }

  changePassword() {

      if (this.$changePasswordForm.invalid) {
          this.footerMessage = "modules.Application.views.accountactivation.textPasswordFormEmptyFields";
          return;
      }

      if (this.$changePasswordForm.value["password"].length < 6 || this.$changePasswordForm.value["password"].length > 20) {
          this.footerMessage = "modules.Application.views.accountactivation.textPasswordMustBeOfLength";
          return;
      }
      
      if (this.$changePasswordForm.value["password"] !== this.$changePasswordForm.value["confirmPassword"]) {
          this.footerMessage = "modules.Application.views.accountactivation.textPasswordsNotMatch";
          return;
      }

      const { password, urlkey } = this.$changePasswordForm.value;
      const url = `${environment.getDataProviders()["SupplierAppProvider"].serviceUri}/web/pdo/Unauthenticated/PusrBusinessEntity/ActivatePusr`;

      this.http.put(url, JSON.stringify({
          newPassword: password,
          urlkey
      }),{ 
          headers: {'Content-Type': 'application/json'},
          withCredentials: true
      }).subscribe(result => {
          this.requestSent = true;
          this.passwordChangeSuccess = result["response"].ResponseSuccess;
      }, error => {
          this.requestSent = true;
          this.passwordChangeSuccess = false;
      });
  }

  getUserStatus(){
    const { urlkey } = this.$changePasswordForm.value;
    const url = `${environment.getDataProviders()["SupplierAppProvider"].serviceUri}/web/pdo/Unauthenticated/PusrBusinessEntity/GetPusrStatus`;

    this.http.put(url, JSON.stringify({
        urlkey
    }),{ 
        headers: {'Content-Type': 'application/json'},
        withCredentials: true
    }).subscribe(result => {
        if(result["response"].ResponseSuccess){
            //redirect user to login page if account is already active
            this.userAlreadyActive = result["response"].UserActive;
            if(this.userAlreadyActive)
                this.backBtn();
            this.$changePasswordForm.patchValue({"userName" : result["response"].UserName});
        }
    }, error => {
        
    });
  }

  public backBtn(){
      this.$router.navigate(['auth-callback']);
  }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-account-activation/djiv-account-activation.component.ts